export default "<div>{{ GetWebhookEvenement(id) }}</div>";